import APITemplate from '@api/APITemplate'
import { formatQueryParams } from '@utils/Format'
import store from '@state/store'
import con from '@services/connection'
import { oportunidadeFunil } from '@modules/crm/constants/URL'
import { buildFunilCompletoPayload } from '@modules/crm/utils/completoPayload'

// Payload completo do kanban de oportunidades (funis -> etapas -> atividades +
// oportunidades por etapa + bucket fechados). Clone de apiCrmFunilCompleto,
// estendido com o GET de leitura do kanban e o endpoint de mover. A montagem
// do payload reusa buildFunilCompletoPayload (testado em utils/completoPayload).
class APICrmOportunidadeFunilCompleto extends APITemplate {
  constructor() {
    super()

    this.MODULE = 'crm'

    // STORE KEYS
    this.KEY_DATA = `${this.MODULE}/oportunidadeFunilCompleto`
    this.KEY_LOADING = `${this.MODULE}/oportunidadeFunilCompletoLoading`

    // STORE ACTIONS
    this.ACTION_SET_DATA = `${this.MODULE}/setOportunidadeFunilCompleto`
    this.ACTION_SET_LOADING = `${this.MODULE}/setOportunidadeFunilCompletoLoading`
  }

  // ---------- HELPERS ----------
  resolveUrl({ tipoOportunidade, idFunil, idClienteApp, idLead } = {}) {
    const params = {}
    if (tipoOportunidade) params.tipo_oportunidade = tipoOportunidade
    if (idFunil) params.id_funil = idFunil
    if (idClienteApp) params.id_cliente_app = idClienteApp
    if (idLead) params.id_lead = idLead

    return oportunidadeFunil.funilCompleto + formatQueryParams(params)
  }

  setDataFromResponse(r) {
    const value = r && r.status === 200 && r.value ? r.value : { funis: [] }
    store.dispatch(this.ACTION_SET_DATA, value)
  }

  // ---------- REQUESTS ----------
  // Leitura do kanban. Filtros opcionais: tipo_oportunidade, id_funil,
  // id_cliente_app, id_lead. Persiste no store quando useStore=true.
  async carregar({
    tipoOportunidade = null,
    idFunil = null,
    idClienteApp = null,
    idLead = null,
    useStore = false,
  } = {}) {
    if (useStore) store.dispatch(this.ACTION_SET_LOADING, true)

    const url = this.resolveUrl({
      tipoOportunidade,
      idFunil,
      idClienteApp,
      idLead,
    })
    const r = await con.get(url)

    if (useStore) {
      this.setDataFromResponse(r)
      store.dispatch(this.ACTION_SET_LOADING, false)
    }

    return (
      r ||
      this.buildErrorResponse({
        message: 'Erro ao carregar o kanban de oportunidades.',
      })
    )
  }

  async salvarCompleto({ funil, etapas } = {}) {
    const payload = buildFunilCompletoPayload({ funil, etapas })
    const r = await con.post(oportunidadeFunil.funilCompleto, {
      data: JSON.stringify(payload),
    })
    return r || {}
  }

  async atualizarCompleto({ id, funil, etapas } = {}) {
    if (!id) {
      return {
        status: 400,
        message: 'Funil sem identificador para atualizar.',
        value: null,
      }
    }
    const payload = buildFunilCompletoPayload({ funil, etapas })
    const r = await con.put(`${oportunidadeFunil.funilCompleto}/${id}`, {
      data: JSON.stringify(payload),
    })
    return r || {}
  }

  // Move a oportunidade para outra etapa (valida funil no backend; materializa
  // atividades em tarefas/timeline). CONTRACT §3.6.
  async mover({ idOportunidade, idFunil, idEtapaDestino } = {}) {
    if (!idOportunidade || !idEtapaDestino) {
      return this.buildErrorResponse({
        status: 400,
        message: 'Dados insuficientes para mover a oportunidade.',
      })
    }

    const dado = {
      id_oportunidade: idOportunidade,
      id_funil: idFunil,
      id_etapa_destino: idEtapaDestino,
    }
    const r = await con.put(oportunidadeFunil.mover, {
      data: JSON.stringify(dado),
    })

    return (
      r ||
      this.buildErrorResponse({
        message: 'Erro ao mover a oportunidade.',
      })
    )
  }
}

const apiCrmOportunidadeFunilCompleto = new APICrmOportunidadeFunilCompleto()
export { apiCrmOportunidadeFunilCompleto }
